import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { Radio } from "@sportal/cdk";
import { RadioOptions } from "@sportal/cdk";
import { AgeGroup } from "@sportal/api";

import "./AgeGroupsOptions.scss";

const ageGroups = [AgeGroup.Kids, AgeGroup.Teens, AgeGroup.Adults];

export const AgeGroupsOptions = ({ selectedValue, onChange }) => {
  return (
    <RadioOptions
      selectedOption={selectedValue}
      name={"age-group"}
      onChange={onChange}
      legend={<FormattedMessage id="age_group" />}
      className={"age-group"}
    >
      {ageGroups.map((ageGroup) => (
        <Radio
          value={ageGroup}
          key={ageGroup}
          id={ageGroup}
          label={<FormattedMessage id={ageGroup} />}
        />
      ))}
    </RadioOptions>
  );
};

AgeGroupsOptions.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
